<template>
  <div class="activity">
     <cube-scroll
       ref="scroll"
       :data="items"
       :options="options"
       @pulling-down="onPullingDown"
       @pulling-up="onPullingUp" class="page_scroll">
    <div class="activity-banner" v-if="swiperSlide.length>0">
       <swiper :options="swiper" ref="Swiper" id="acSwiper">
          <swiper-slide v-for="(slide, index) in swiperSlide" :key="index">
            <router-link :to="{ name:'news', params: { news_id: slide.news_id}}">
              <!-- :href= "slide.news_id" -->
                <a class="swiper-img">
                  <img :src= "slide.img" alt="">
                </a>
            </router-link>
          </swiper-slide>
          <div class="swiper-pagination" id="Acpagnation" slot="pagination"></div>
        </swiper> 
    </div>
    <div class="list">
      <!-- <h5 class='title'>儿童基因身份是什么？</h5> -->
      <ul class="activity-ul">
          <li v-for="(item, index) in activityInfo" :key="index">
            <router-link :to="{ name:'news', params: { news_id: item.news_id}}">
              <a href="javascript:;" class="list-activity">
                <img v-lazy ="item.img" alt="">
                <div class="list-content">
                    <p class="list-detail">{{item.title}}</p>
                    <p class="list-time">{{item.time}}</p>
                </div>
              </a>
            </router-link>
          </li>
          <!-- <li>
              <a href="javascript:;" class="list-activity">
                <img src="" alt="">
                <div class="list-content">
                    <p class="list-detail">这种病毒好发于夏秋季，“六一” 前后是高发期，宝妈们要注意...</p>
                    <p class="list-time">2019年5月31日</p>
                </div>
              </a>
          </li>
          <li>
              <a href="javascript:;" class="list-activity">
                <img src="" alt="">
                <div class="list-content">
                    <p class="list-detail">这种病毒好发于夏秋季，“六一” 前后是高发期，宝妈们要注意...</p>
                    <p class="list-time">2019年5月31日</p>
                </div>
              </a>
          </li> -->
      </ul>
    </div>
   </cube-scroll>
  </div>
</template>
<script>
export default {
  name: 'activity',
  data () {
    return {
      swiper: {
        notNextTick: true,
        //循环
        loop:true,
        //设定初始化时slide的索引
        initialSlide:0,
        //自动播放
        autoplay:false,
        // autoplay: {
        //     delay: 3000,
        //     stopOnLastSlide: false,
        //     disableOnInteraction: true,
        // },
        // 设置轮播
        effect : 'slide',
        //滑动速度
        speed:800,
        //滑动方向
        // direction : 'horizontal',
        //小手掌抓取滑动
        // grabCursor : true,
        //滑动之后回调函数
        on: {
            slideChangeTransitionEnd: function(){
                // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            },
        },
        //左右点击
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        //分页器设置         
        pagination: {
            el: '.swiper-pagination',
            clickable :true,
            // bulletActiveClass: 'my-bullet-active',
        }
      },
      swiperSlide: [],
      activityInfo: [],
      pageNum: 1,
      allpage: null,
      items: [],
      options: {
          pullUpLoad: {
            threshold: 60,
            txt: {
              more: '加载更多',
              // noMore: '没有更多了'
            }
          },
          pullDownRefresh: {
            threshold: 60,
            // stop:,
            // stopTime:,
            txt: '刷新成功'
          },
      },
    }
  },
  mounted () {
    this.$loading.show()
  },
  created () {
    this.loadPage(1, 1)
  },
  methods: {
    loadPage (pageNum, type) {

      let _this = this
      // 加载banner
      this.$http.api.newRecommend({}).then(result => {
        this.swiperSlide = [...result]
      })
      // 活动中心
      this.$http.api.activityCenter({
        page: pageNum,
        size: 10
      }).then(result => {
        // this.activityInfo = [...result]
         this.$loading.hide()
          _this.allpage = Math.ceil(result.total/10)
          let data = result.rows
          if (type === 1) {
            _this.activityInfo = [...data]
            _this.$refs.scroll.forceUpdate()
            _this.pageNum = 2
          } else {
            if (data.length > 0 && _this.pageNum <=  _this.allpage) {
               _this.activityInfo = _this.activityInfo.concat(data)
              _this.pageNum = _this.pageNum + 1
               _this.$refs.scroll.forceUpdate()
            }
            // else {
            //   _this.$refs.scroll.forceUpdate()
            // }
          }
      })
      if( _this.pageNum > _this.allpage){
          setTimeout(function () {
            _this.$refs.scroll.forceUpdate()
          }, 300)
      }
    },
    onPullingDown () {
        // this.isLoading = false
        this.loadPage(1, 1)
      },
    onPullingUp () {
        let _this = this
        // _this.isLoading = false
        setTimeout(function () {
          _this.loadPage(_this.pageNum, 2)
        }, 800)
    },
  }
}
</script>
<style lang="less" scoped>
.activity {
  width: 100%;
  padding: 19px 15px 0;
  box-sizing: border-box;
  .activity-banner {
    width: 100%;
    margin: 0 auto;
    #acSwiper{
      border-radius:10px 10px 0px 0px;
      .swiper-img {
        img {
          width: 100%;
        }
      }
    }
    #Acpagnation /deep/ .swiper-pagination-bullet {
      background: #fff;
      opacity: .8;
    }
    #Acpagnation /deep/ .swiper-pagination-bullet-active {
      width:12px;
      height:5px;
      background:#007aff;
      border-radius:6px;
      opacity: 1;
    }
  }
  .list {
    width: 100%;
    h5.title {
      width: 100%;
      padding: 12px 10px;
      background: #fff;
      box-sizing: border-box;
      font-size:15px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(26,26,26,1);
      border-bottom: 1px solid rgba(179,179,179,.8);
    }
    ul.activity-ul {
      width: 100%;
      li {
        border-bottom: 1px solid rgba(179,179,179,.8);
        padding: 10px;
        box-sizing: border-box;
        background: #fff;
        a{
          display: block;
          width: 100%;
          img{
            width: 85px;
            height: 72px;
            float: left;
            margin-right: 5px;
          }
          .list-content {
            // width: 70%;
            min-height: 72px;
            .list-detail {
            //   width:410px;
            //   height:67px;
              font-size:14px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(26,26,26,1);
              margin-bottom: 9px;
              padding-top: 8px;
            //   line-height:39px;
            }
            .list-time {
            //   width:171px;
            //   height:24px;
              font-size:12px;
              font-family:MicrosoftYaHei;
              font-weight:400;
              color:rgba(179,179,179,1);
            //   line-height:39px;
            }
          }
        }
      }
    }
  }
}
</style>


